import { MailboxIcon, RocketLaunchIcon, UsersThreeIcon } from '@phosphor-icons/react';
import { DealTypeEnumType } from '__generated__/graphql';
import { useMemo } from 'react';
import { Outlet } from 'react-router-dom';

import SidebarLayout, {
  SidebarLayoutContent,
  SidebarLayoutNavigation,
  type SidebarLayoutSecondaryTab,
} from 'layouts/SidebarLayout';

import { InvestPageNavProvider, useInvestPageNav } from './InvestPageNavContext';
import {
  INVEST_HUB_DEAL_INVITES_PATH,
  INVEST_HUB_RUVS_PATH,
  INVEST_HUB_SYNDICATES_PATH,
} from './investHubPaths';

/** `dealType` marks the tabs that carry a deal count; Deal Invites has none. */
type InvestSecondaryTab = SidebarLayoutSecondaryTab & { dealType?: DealTypeEnumType };

const investSecondaryTabs: InvestSecondaryTab[] = [
  {
    key: 'syndicates',
    label: 'Syndicates',
    description: '',
    route: INVEST_HUB_SYNDICATES_PATH,
    icon: UsersThreeIcon,
    exact: true,
    dealType: DealTypeEnumType.Syndicated,
  },
  {
    key: 'ruvs',
    label: 'RUVs',
    description: '',
    route: INVEST_HUB_RUVS_PATH,
    icon: RocketLaunchIcon,
    dealType: DealTypeEnumType.Ruv,
  },
  {
    key: 'deal-invites',
    label: 'Deal Invites',
    description: '',
    route: INVEST_HUB_DEAL_INVITES_PATH,
    icon: MailboxIcon,
  },
];

function InvestPageLayoutInner() {
  const { navMeta, dealTypeCounts, hideTabHighlight } = useInvestPageNav();

  // Counts arrive once the discover query resolves; until then the tabs render bare.
  const secondaryTabs = useMemo(
    () =>
      investSecondaryTabs.map(tab => {
        const badge = tab.dealType ? dealTypeCounts[tab.dealType] : undefined;
        return typeof badge === 'number' ? { ...tab, badge } : tab;
      }),
    [dealTypeCounts]
  );

  return (
    <>
      <SidebarLayoutNavigation
        title="Invest"
        subTitle={navMeta.subTitle}
        onBackButtonClick={navMeta.onBackButtonClick}
        secondaryTabs={secondaryTabs}
        rightContent={navMeta.navRightContent}
        hideTabHighlight={hideTabHighlight}
      />
      <SidebarLayoutContent>
        <Outlet />
      </SidebarLayoutContent>
    </>
  );
}

export default function InvestPageLayout() {
  return (
    <SidebarLayout>
      <InvestPageNavProvider>
        <InvestPageLayoutInner />
      </InvestPageNavProvider>
    </SidebarLayout>
  );
}
